import { Chip } from '@servicetitan/anvil2';
import { LoanStatus2 } from '@servicetitan/financing-api-client';
import { getStatusColor, getLoanStatusDisplayText } from '../core/loan-status';

export interface LoanStatusChipProps {
    status: LoanStatus2;
    providerName?: string | null;
}

export const LoanStatusChip = ({ status, providerName }: LoanStatusChipProps) => {
    return (
        <Chip
            label={getLoanStatusDisplayText(status, providerName)}
            color={getStatusColor(status)}
        />
    );
};
